import React, { ReactElement } from "react";

import DeviceTypeEnum from "../../../enums/DeviceTypeEnum";
import Image from "../../../components/image/Image";

import styles from "./topbarlogo.module.scss";
import { Link } from "react-router-dom";

interface IProps { 
    type: DeviceTypeEnum;
}
  
const TopBarLogo : React.FC<IProps> = (props) => {
  
  let logoClass = (type: string) => {
    switch (type) {
      case DeviceTypeEnum.MOBILE:
        return `d-md-none ${styles.topbarLogo}`;
      case DeviceTypeEnum.DESKTOP:
        return `d-none d-md-flex navbar-brand ${styles.topbarLogo}`;
      default:
        return "d-none";
    }
  }

  return (
    <Link to="/" className={logoClass(props.type)}>
      <Image imgPath="logo.png" className={styles.topbarLogoImg} alt="Logo" />
    </Link>
  );
}; 

export default TopBarLogo;